import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useRef, type PropsWithChildren, type Ref } from 'react';
import { CONTENT_CLASSNAME } from 'shared/layout/constants/layout-class-names';
import { twJoin } from 'tailwind-merge';
const NAVBAR_HEIGHT_PROPERTY = '--dashboard-navbar-height';
interface NavbarBaseProps extends PropsWithChildren {
  contentRef?: Ref<HTMLDivElement>;
}
export function NavbarBase(t0) {
  const $ = _c(6);
  const {
    children,
    contentRef
  } = t0;
  const headerRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const header = headerRef.current;
      if (!header) {
        return;
      }
      const updateNavbarHeight = () => {
        document.documentElement.style.setProperty(NAVBAR_HEIGHT_PROPERTY, `${header.offsetHeight}px`);
      };
      updateNavbarHeight();
      const resizeObserver = new ResizeObserver(updateNavbarHeight);
      resizeObserver.observe(header);
      return () => {
        resizeObserver.disconnect();
        document.documentElement.style.removeProperty(NAVBAR_HEIGHT_PROPERTY);
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useLayoutEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = twJoin(CONTENT_CLASSNAME, "flex items-center gap-3 py-2");
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== contentRef) {
    t4 = <header ref={headerRef} className="border-border-100 bg-bg-primary sticky top-0 z-50 border-b"><div ref={contentRef} className={t3}>{children}</div></header>;
    $[3] = children;
    $[4] = contentRef;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}